module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-menu"
  }, [_c('div', {
    staticClass: "ui vertical menu"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Model (value by v-model)")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/Model'
      }
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/ModelList'
      }
    }
  }, [_vm._v("ModelList")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/ModelAjax'
      }
    }
  }, [_vm._v("Ajax sample")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Multi")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/Multi'
      }
    }
  }, [_vm._v("Multi")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/MultiList'
      }
    }
  }, [_vm._v("Multi List")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/Basic'
      }
    }
  }, [_vm._v("Basic")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/CustomFilter'
      }
    }
  }, [_vm._v("Custom Filter")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/List'
      }
    }
  }, [_vm._v("List")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        path: '/ListCustomText'
      }
    }
  }, [_vm._v("List Custom Text")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-content"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a481c63a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 404
// module chunks = 2